/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LoaderThreeDots/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function LoaderThreeDots({
  children,
  viewPath = "/DesignSystem/LoaderThreeDots"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="LoaderThreeDots.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="LoaderThreeDots.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
/>
<div
  data-testid="LoaderThreeDots.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="LoaderThreeDots.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
/>
</div>
{children}
</React.Fragment>)
}